module.exports = __webpack_public_path__ + "fonts/xjAJXh38I15wypJXxuGMBtDiNsR5a-9Oe_Ivpu8XWlY.woff2";